module.exports = __webpack_public_path__ + "static/media/number1.dc62c72e.mp3";